import React, { useEffect, useState } from "react";
import BaseURL from "../../../assets/utils/baseUrl";
import MUIDataTable from "mui-datatables";
import { Button, Footer, HeaderAdmin } from "../../../components";
import { TextField } from "@material-ui/core";
import { Loader } from "../../../assets";

function KelolaApbd({ setToken }) {
  const [apbd, setApbd] = useState(null);
  const [modal, setModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(true);
  const [popUp, setPopUp] = useState(false);
  const [success, setSuccess] = useState(true);
  const [load, setLoad] = useState(true);
  const [loading, setLoading] = useState(true);
  const [alertTahun, setAlertTahun] = useState(false);
  const [alertPad, setAlertPad] = useState(false);
  const [alertDanaPerimbangan, setAlertDanaPerimbangan] = useState(false);
  const [alertLainLainPendapatan, setAlertLainLainPendapatan] = useState(false);
  const [alertPembiayaan, setAlertPembiayaan] = useState(false);
  const [formData, setFormData] = useState({
    tahun: "",
    pad: "",
    dana_perimbangan: "",
    lain_lain_pendapatan: "",
    pembiayaan: "",
    created_date: "",
  });
  const [id, setId] = useState("");

  useEffect(() => {
    setLoading(true);
    const getData = async () => {
      await fetch(BaseURL + "index.php/api/Apbd")
        .then((res) => res.json())
        .then((data) => {
          setApbd(data.data);
          setLoading(false);
        });
    };
    getData();
  }, [load]);

  const columns = [
    {
      name: "tahun",
      label: "Tahun",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return <div style={{ width: 200 }}>{value}</div>;
        },
      },
    },
    {
      name: "pad",
      label: "PAD",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "dana_perimbangan",
      label: "Dana Perimbangan",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "lain_lain_pendapatan",
      label: "Pendapatan Lain-lain",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "pembiayaan",
      label: "Pembiayaan",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "tanggal_post",
      label: "Tanggal Post",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return <div style={{ width: 100 }}>{value}</div>;
        },
      },
    },
    {
      name: "opsi",
      label: "Opsi",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div className="tooltip btn-hapus-row" onClick={() => hapus(value)}>
                <i className="fas fa-trash-alt"></i>
                <span className="tooltiptext">Hapus</span>
              </div>
              <div
                className="tooltip btn-edit-row"
                onClick={() => {
                  setUpdateModal(true);
                  openUpdateModal(value);
                }}
              >
                <i className="fas fa-edit"></i>
                <span className="tooltiptext">Update</span>
              </div>
            </div>
          );
        },
      },
    },
  ];

  const options = {
    sort: true,
    filter: false,
    download: false,
    print: false,
    selectableRows: false,
  };

  let tablesData = [];

  if (apbd) {
    let date = [];
    for (let i = 0; i < apbd.length; i++) {
      let tempDate = "";
      tempDate = apbd[i].created_date;
      date = tempDate.split("-");
      if (date[1] != "10") {
        date[1] = date[1].replace("0", "");
      }
      let m = "";
      switch (date[1]) {
        case "1":
          m = "Januari";
          break;
        case "2":
          m = "Februari";
          break;
        case "3":
          m = "Maret";
          break;
        case "4":
          m = "April";
          break;
        case "5":
          m = "Mei";
          break;
        case "6":
          m = "Juni";
          break;
        case "7":
          m = "Juli";
          break;
        case "8":
          m = "Agustus";
          break;
        case "9":
          m = "September";
          break;
        case "10":
          m = "Oktober";
          break;
        case "11":
          m = "November";
          break;
        case "12":
          m = "Desember";
          break;
        default:
          m = "-";
      }
      date = date[2] + " " + m + " " + date[0];
      tablesData.push({
        tahun: apbd[i].tahun,
        pad: apbd[i].pad,
        dana_perimbangan: apbd[i].dana_perimbangan,
        lain_lain_pendapatan: apbd[i].lain_lain_pendapatan,
        pembiayaan: apbd[i].pembiayaan,
        tanggal_post: date,
        opsi: apbd[i].id_apbd,
      });
    }
  }

  const tambah = () => {
    if (formData.tahun == "") {
      setAlertTahun(true);
    } else {
      setAlertTahun(false);
    }

    if (formData.pad == "") {
      setAlertPad(true);
    } else {
      setAlertPad(false);
    }

    if (formData.dana_perimbangan == null) {
      setAlertDanaPerimbangan(true);
    } else {
      setAlertDanaPerimbangan(false);
    }

    if (formData.lain_lain_pendapatan == null) {
      setAlertLainLainPendapatan(true);
    } else {
      setAlertLainLainPendapatan(false);
    }

    if (formData.pembiayaan == null) {
      setAlertPembiayaan(true);
    } else {
      setAlertPembiayaan(false);
    }

    if (formData.tahun !== "" && formData.pad !== "" && formData.dana_perimbangan !== null && formData.lain_lain_pendapatan !== null && formData.pembiayaan !== null) {
      const data = new FormData();
      let today = new Date();
      let date = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
      data.append("request", "post");
      data.append("tahun", formData.tahun);
      data.append("pad", formData.pad);
      data.append("dana_perimbangan", formData.dana_perimbangan);
      data.append("lain_lain_pendapatan", formData.lain_lain_pendapatan);
      data.append("pembiayaan", formData.pembiayaan);
      data.append("id_user", localStorage.getItem("id"));
      data.append("created_date", date);

      try {
        fetch(BaseURL + "index.php/api/apbd", {
          method: "POST",
          body: data,
        })
          .then((response) => response.json())
          .then((data) => {
            setFormData({
              tahun: "",
              pad: "",
              dana_perimbangan: "",
              lain_lain_pendapatan: "",
              pembiayaan: "",
              created_date: "",
            });
            setLoad(!load);
            setModal(false);
            setUpdateModal(false);
            if (data.status) {
              setSuccess(true);
            } else {
              setSuccess(false);
            }
            setPopUp(true);
          })
          .catch((error) => console.log("Gagal: ", error));
      } catch (error) {
        alert("Terjadi kesalahan pada sistem");
        console.log(error);
      }
    }
  };

  const hapus = ($id) => {
    try {
      fetch(BaseURL + "index.php/api/apbd/" + $id, {
        method: "DELETE",
      })
        .then((response) => response.json())
        .then((data) => {
          setLoad(!load);
          if (data.status) {
            setSuccess(true);
          } else {
            setSuccess(false);
          }
          setPopUp(true);
        })
        .catch((error) => console.log("Gagal: ", error));
    } catch (error) {
      alert("Terjadi kesalahan pada sistem");
      console.log(error);
    }
  };

  const openUpdateModal = ($id) => {
    const getDataUpdate = async () => {
      await fetch(BaseURL + "index.php/api/apbd?id=" + $id)
        .then((res) => res.json())
        .then((data) => {
          setFormData({
            tahun: data.data[0].tahun,
            pad: data.data[0].pad,
            dana_perimbangan: data.data[0].dana_perimbangan,
            lain_lain_pendapatan: data.data[0].lain_lain_pendapatan,
            pembiayaan: data.data[0].pembiayaan,
            created_date: data.data[0].created_date,
          });
          setId($id);
          setModal(true);
        });
    };
    getDataUpdate();
  };

  const update = () => {
    if (formData.tahun == "") {
      setAlertTahun(true);
    } else {
      setAlertTahun(false);
    }

    if (formData.pad == "") {
      setAlertPad(true);
    } else {
      setAlertPad(false);
    }

    if (formData.dana_perimbangan == null) {
      setAlertDanaPerimbangan(true);
    } else {
      setAlertDanaPerimbangan(false);
    }

    if (formData.lain_lain_pendapatan == null) {
      setAlertLainLainPendapatan(true);
    } else {
      setAlertLainLainPendapatan(false);
    }

    if (formData.pembiayaan == null) {
      setAlertPembiayaan(true);
    } else {
      setAlertPembiayaan(false);
    }

    if (formData.tahun !== "" && formData.pad !== "" && formData.dana_perimbangan !== null && formData.lain_lain_pendapatan !== null && formData.pembiayaan !== null) {
      const data = new FormData();
      let today = new Date();
      let date = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
      data.append("request", "put");
      data.append("id_apbd", id);
      data.append("tahun", formData.tahun);
      data.append("pad", formData.pad);
      data.append("dana_perimbangan", formData.dana_perimbangan);
      data.append("lain_lain_pendapatan", formData.lain_lain_pendapatan);
      data.append("pembiayaan", formData.pembiayaan);
      data.append("id_user", localStorage.getItem("id"));
      data.append("created_date", formData.created_date);
      data.append("updated_date", date);

      try {
        fetch(BaseURL + "index.php/api/apbd", {
          method: "POST",
          body: data,
        })
          .then((response) => response.json())
          .then((data) => {
            setFormData({
              tahun: "",
              pad: "",
              dana_perimbangan: "",
              lain_lain_pendapatan: "",
              pembiayaan: "",
              created_date: "",
            });
            setLoad(!load);
            setModal(false);
            setUpdateModal(false);
            if (data.status) {
              setSuccess(true);
            } else {
              setSuccess(false);
            }
            setPopUp(true);
          })
          .catch((error) => console.log("Gagal: ", error));
      } catch (error) {
        alert("Terjadi kesalahan pada sistem");
        console.log(error);
      }
    }
  };

  return (
    <div className="page">
      <HeaderAdmin title="Kelola APBD" setToken={(e) => setToken(e)} />
      <div className="main-admin">
        <div className="container-admin">
          <div style={{ height: 50 }} />
          <Button
            title="Tambah Post"
            type="primary"
            onClick={() => {
              setUpdateModal(false);
              setModal(true);
            }}
          />
          <div style={{ height: 10 }} />
          {loading ? (
            <div className="loader">
              <img src={Loader}></img>
            </div>
          ) : (
            <MUIDataTable title={"Daftar APBD"} data={tablesData} columns={columns} options={options} download={false} className="table" />
          )}
        </div>
      </div>
      <Footer />

      {/* modal */}
      <div className={modal ? "darker-bg-admin" : "darker-bg-admin hide"}>
        {/* form */}
        <div className="modal-admin">
          <div className="form-admin">
            <TextField type="number" id="tahun" label="Tahun" variant="outlined" style={{ marginTop: 10, marginBottom: 10 }} onChange={(e) => setFormData({ ...formData, tahun: e.target.value })} value={formData.tahun} />
            {alertTahun && <div className="danger-alert">Tahun tidak boleh kosong</div>}

            <TextField type="number" id="pad" label="PAD" variant="outlined" style={{ marginTop: 10, marginBottom: 10 }} onChange={(e) => setFormData({ ...formData, pad: e.target.value })} value={formData.pad} />
            {alertPad && <div className="danger-alert">PAD tidak boleh kosong</div>}

            <TextField
              type="number"
              id="dana_perimbangan"
              label="Dana Perimbangan"
              variant="outlined"
              style={{ marginTop: 10, marginBottom: 10 }}
              onChange={(e) => setFormData({ ...formData, dana_perimbangan: e.target.value })}
              value={formData.dana_perimbangan}
            />
            {alertDanaPerimbangan && <div className="danger-alert">Dana Perimbangan tidak boleh kosong</div>}

            <TextField
              type="number"
              id="lain_lain_pendapatan"
              label="Pendapatan Lain-lain"
              variant="outlined"
              style={{ marginTop: 10, marginBottom: 10 }}
              onChange={(e) => setFormData({ ...formData, lain_lain_pendapatan: e.target.value })}
              value={formData.lain_lain_pendapatan}
            />
            {alertLainLainPendapatan && <div className="danger-alert">Pendapatan Lain-lain tidak boleh kosong</div>}

            <TextField type="number" id="pembiayaan" label="Pembiayaan" variant="outlined" style={{ marginTop: 10, marginBottom: 10 }} onChange={(e) => setFormData({ ...formData, pembiayaan: e.target.value })} value={formData.pembiayaan} />
            {alertPembiayaan && <div className="danger-alert">Pembiayaan tidak boleh kosong</div>}
          </div>

          <div style={{ height: 30 }}></div>

          <div className="form-option">
            <Button
              title={updateModal ? "Update" : "Tambah"}
              type="primary"
              onClick={() => {
                if (updateModal) {
                  update();
                } else {
                  tambah();
                }
              }}
            />
            <div style={{ width: 10 }}></div>
            <Button
              title="Batal"
              type="danger"
              onClick={() => {
                setModal(false);
                setUpdateModal(false);
                setFormData({
                  tahun: "",
                  pad: "",
                  dana_perimbangan: "",
                  lain_lain_pendapatan: "",
                  pembiayaan: "",
                  created_date: "",
                });
                setAlertTahun(false);
                setAlertPad(false);
                setAlertDanaPerimbangan(false);
                setAlertLainLainPendapatan(false);
                setAlertPembiayaan(false);
              }}
            />
          </div>
        </div>
      </div>

      {/* message pop up */}
      <div className={popUp ? "darker-bg-admin" : "darker-bg-admin hide"}>
        <div className="pop-up-admin">
          <i className={success ? "fas fa-check-circle pop-up-logo" : "fas fa-times-circle pop-up-logo failed-pop-up"}></i>
          {success ? <p>Berhasil</p> : <p className={success ? "" : "failed-pop-up"}>Gagal</p>}
          <div style={{ height: 20 }}></div>
          <Button
            title="Tutup"
            type="primary"
            onClick={() => {
              setAlertTahun(false);
              setAlertPad(false);
              setAlertDanaPerimbangan(false);
              setAlertLainLainPendapatan(false);
              setAlertPembiayaan(false);
              setPopUp(false);
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default KelolaApbd;
